import React from 'react'
import {Main9SectionWrap} from 'src/styles/views/Main/main9'
import {CustomBtn} from 'src/styles/common/CommonForm/buttonform'
import {APP_STORE_WARD, IOS_APP_STORE_WARD, MO_APP_STORE_WARD} from 'src/service/constant/url'
import useWindowDimensions from "src/hooks/useGetWindowSize"
import {COLOR} from "src/service/constant/color"
import {deviceDetection} from "src/service/utils"

const Main9Section = () => {
    const {width} = useWindowDimensions()

    const onClickAppDownload = () => {
        switch(deviceDetection()){
            case "AOS":
                window.open(width > 1200 ? APP_STORE_WARD : MO_APP_STORE_WARD)
                break
            case "IOS":
                window.open(IOS_APP_STORE_WARD)
                break
        }
    }

    return (
        <Main9SectionWrap>
            {width > 1200 ?
                <h3>언제, 어디서나 가족과의 연결은 <br/> 계속되어야 합니다.</h3> :
                <h3>언제, 어디서나 가족과의 <br/> 연결은 계속되어야 합니다.</h3>
            }
            {width > 1200 &&
                <CustomBtn
                color={width > 1200 ? COLOR.point1 : COLOR.white}
                bgColor={width > 1200 ? COLOR.white : COLOR.point1}
                borderColor={width > 1200 ? COLOR.point1 : undefined}
                marginTop={width > 1200 ? "0px" : "41px"}
                width={width > 1200 ? "296px" : "247px"}
                fontSize={"18px"}
                height={"48px"}
                borderRadius={"40px"}
                fontFamily={width > 1200 ? "NanumSquareNeoHeavy, sans-serif" : "NotoSansBold, sans-serif"}
                onClick={onClickAppDownload}
            >
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a>앱 설치하기</a>
            </CustomBtn>
            }
        </Main9SectionWrap>
    )
}
export default Main9Section
